import API from './registrationAPI';
import {
  REGISTRATION_DATA, REGISTER_BUSINESS_SUCCESS, REGISTER_BUSINESS_FAIL, SET_MESSAGE,
} from '../types';

export const registrationLists = () => async (dispatch) => {
  const regLists = await API.Registration;
  dispatch({
    type: REGISTRATION_DATA,
    payload: regLists,
  });
};

export const register = (businessDetails) => async (dispatch) => API.register(businessDetails).then(
  // eslint-disable-next-line no-unused-vars
  async (response) => {
    dispatch({
      type: REGISTER_BUSINESS_SUCCESS,
      payload: response.data,
    });
    const regLists = await API.Registration;
    dispatch({
      type: REGISTRATION_DATA,
      payload: regLists,
    });

    dispatch({
      type: SET_MESSAGE,
      // payload: response.data.meta,
    });
    return Promise.resolve();
  },
  (error) => {
    const message = (error.response
          && error.response.data
          && error.response.data.message)
        || error.message
        || error.toString();

    dispatch({
      type: REGISTER_BUSINESS_FAIL,
      payload: { error },
    });

    dispatch({
      type: SET_MESSAGE,
      payload: message,
    });

    return Promise.reject();
  },
);
